<template>
  <transition appear name="fade">
    <div class="col-md-9 p-4">
      <h4>Business Units</h4>
      <hr />
      <div class="buisnessUnitsActions">
        <b-button variant="primary" @click="showModal('buisnessUnitTypes')">Business Unit Types</b-button>
        <b-button variant="primary" @click="showModal('addUnit')">Add Unit </b-button>
        <b-button variant="primary" @click="showModal('associateUnit')">Associate Unit </b-button>
      </div>
      <div class="buisnessUnitsContainer" v-if="selectedUnit">
        <fieldset class="clientTree" v-if="Tree && Tree.length > 0">
          <legend>{{ Customer.customername }}</legend>
          <div>
            <a-tree :show-line="true" :tree-data="Tree" @select="onSelect"> </a-tree>
          </div>
        </fieldset>
        <fieldset class="businessUnit">
          <legend>Business unit</legend>
          <a-spin :spinning="Status === 'saving'">
            <label> Unit name:</label>
            <a-input :value="selectedUnit.title" :disabled="true" />
            <label>Unit type:</label>
            <a-select v-model="selectedUnit.unit_type_id" :disabled="selectedUnit.key === Tree[0].key">
              <a-select-option v-for="unitType in UnitTypes" :value="unitType.unit_type_id" :key="unitType.unit_type_id">
                {{ unitType.unit_type_name }}
              </a-select-option>
            </a-select>
            <div class="buisnessUnitsActions">
              <b-button variant="primary" :disabled="selectedUnit.key === Tree[0].key" @click="updateBusinessUnitById()">Update Unit Type</b-button>
              <b-button
                variant="primary"
                :to="{
                  name: 'EditClient',
                  params: {
                    Id: selectedUnit.key,
                  },
                }"
                >Edit Client
              </b-button>
              <b-button variant="primary" @click="unassociateUnit()">Unassociate Unit</b-button>
            </div>
          </a-spin>
        </fieldset>
      </div>
      <business-unit-types v-if="OpenModal === 'buisnessUnitTypes'" />
      <add-unit :selectedUnit="selectedUnit" v-if="OpenModal === 'addUnit'" />
      <associate-unit :selectedUnit="selectedUnit" v-if="OpenModal === 'associateUnit'" />
    </div>
  </transition>
</template>
<script>
import { mapState } from 'vuex';
import BusinessUnitTypes from './BuisnessTypes.vue';
import AddUnit from './AddUnit.vue';
import AssociateUnit from './AssociateUnit.vue';
export default {
  name: 'EditBuisnessUnits',
  props: {
    customerId: Number,
    masterClientId: Number,
  },
  components: { BusinessUnitTypes, AddUnit, AssociateUnit },
  data() {
    return { selectedUnit: null };
  },
  mounted() {
    this.$store.dispatch('businessUnits/getUnitTypes');
    this.$store.dispatch('businessUnits/getClients');
    this.$store.dispatch('businessUnits/getCustomer', this.customerId);
    this.$store.dispatch('businessUnits/getBusinessUnit', this.masterClientId);
    this.$store.dispatch('businessUnits/getTree', this.customerId);
  },
  computed: {
    ...mapState({
      Tree: (state) => state.businessUnits.Tree,
      TreeData: (state) => state.businessUnits.TreeData,
      UnitTypes: (state) => state.businessUnits.UnitTypes,
      Status: (state) => state.businessUnits.Status,
      OpenModal: (state) => state.businessUnits.OpenModal,
      Customer: (state) => state.businessUnits.Customer,
    }),
  },
  methods: {
    onSelect(selectedKey) {
      console.log('selected', selectedKey);
      if (selectedKey.length > 0) {
        this.selectedUnit = this.TreeData.find(({ key }) => key === selectedKey[0]);
      } else {
        this.selectedUnit = this.Tree[0];
      }
    },
    updateBusinessUnitById() {
      this.$store
        .dispatch('businessUnits/updateBusinessUnitById', { id: this.selectedUnit.key, unitTypeId: this.selectedUnit.unit_type_id })
        .then(() => {
          this.$store.dispatch('businessUnits/getTree', this.customerId);
        });
    },
    unassociateUnit() {
      this.$store.dispatch('businessUnits/unassociateUnit', { id: this.selectedUnit.key, parentId: this.selectedUnit.parent_id }).then(() => {
        this.selectedUnit = null;
        this.$store.dispatch('businessUnits/getTree', this.customerId);
      });
    },
    showModal(type) {
      this.$store.dispatch('businessUnits/updateOpenModal', type);
    },
  },
  watch: {
    Tree(newValue) {
      if (newValue?.length > 0 && !this.selectedUnit) {
        this.selectedUnit = newValue[0];
      }
    },
  },
};
</script>
<style lang="scss">
.buisnessUnitsContainer {
  @mixin form-field {
    background-color: #f0f9ff !important;
    height: calc(1.5em + 1rem);
    border-radius: 0.4rem;
    border: 0 solid #ced4da !important;
    box-shadow: inset 1px 1px 3px rgb(157 193 216 / 50%);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  display: flex;
  width: 95%;
  justify-content: space-between;
  margin-left: 4.5%;
  flex-wrap: wrap;
  & > fieldset {
    min-height: 200px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 2%;
    .buisnessUnitsActions {
      margin-left: 0%;
    }
    & > legend {
      width: fit-content;
      float: none;
      margin-left: 10%;
    }
    .ant-spin-container {
      .ant-select,
      & > .ant-input {
        width: 100%;
        min-width: 20px;
        margin-bottom: 2%;
      }
      .ant-select-selection.ant-select-selection--single,
      & > .ant-input {
        @include form-field();
        .ant-select-selection__rendered {
          line-height: 36px;
        }
      }
    }
  }
  .clientTree {
    flex-basis: 30%;
    min-width: 200px;
  }
  .businessUnit {
    flex-basis: 50%;
    min-width: 500px;
  }
}
.buisnessUnitsActions {
  display: flex;
  justify-content: flex-start;
  margin-left: 3.5%;
  & > .btn {
    margin: 0% 0.75%;
    margin-bottom: 1.5%;
    border-radius: 5px;
  }
}
</style>
